import '../../Button.scss';

export interface IButtonTextProps {
  text: string;
}

const ButtonText = ({ text }: IButtonTextProps) => {
  return <div className='button-text'>{text}</div>;
};

export default ButtonText;
